import React from "react";
import clsx from "clsx";

// Helpers
import { LINKS } from "helpers/constants";

// Components
import AppMenuItem from "components/Layout/AppMenuItem";
import HeaderUser from "./HeaderUser";

// Icons
import HomeIcon from "@mui/icons-material/Home";
import ProductIcon from "icons/ProductIcon";
import AttributeIcon from "@mui/icons-material/Assignment";
import CatalogIcon from "icons/CatalogIcon";
import CampaignIcon from "icons/CampaignIcon";
import AccountIcon from "@mui/icons-material/AccountBox";
import CustomerIcon from "@mui/icons-material/PeopleAlt";
import SettingIcon from "@mui/icons-material/Settings";
import ThemesIcon from "@mui/icons-material/ColorLens";
import MediaLibraryIcon from "@mui/icons-material/PermMediaSharp";
import BroadcastIcon from "@mui/icons-material/SettingsInputAntenna";
import SiteComponentIcon from "@mui/icons-material/WebSharp";
import BookIcon from "@mui/icons-material/Book";
import DashboardIcon from '@mui/icons-material/Dashboard'; 
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted'; 
import NotificationsIcon from '@mui/icons-material/Notifications';
import ScheduleIcon from '@mui/icons-material/Schedule';

// Material-UI
import { Theme } from "@mui/material/styles";
import  { makeStyles } from "@mui/styles";
import List from "@mui/material/List";
import ListSubheader from "@mui/material/ListSubheader";
import Divider from "@mui/material/Divider";

interface Props {}

const AppMenu: React.FC<Props> = (props) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.main}>
        {/* <ButtonGroup className={classes.buttonGroup} color="primary" size="small" fullWidth aria-label="outlined primary button group">
					<Button variant="outlined" disableElevation data-selected={view === 1} onClick={() => setView(1)}>All</Button>
					<Button variant="outlined" disableElevation data-selected={view === 2} onClick={() => setView(2)}>Favorites</Button>
				</ButtonGroup> */}

        {/* <ListSubheader component="div" className={classes.subheader}>
          Main
        </ListSubheader>
        <List component="nav" className={clsx(classes.list, classes.iconList)}>
          <AppMenuItem name="Home" url={LINKS.HOME} icon={<HomeIcon />} />
          <AppMenuItem name="Products" url="/products" icon={<ProductIcon />} />
          <AppMenuItem
            name="Attributes"
            url="/attributes"
            icon={<AttributeIcon />}
          />
          <AppMenuItem name="Catalogs" url="/catalogs" icon={<CatalogIcon />} />
          <AppMenuItem
            name="Customers"
            url="/customers"
            icon={<CustomerIcon />}
          />
          <AppMenuItem
            name="Media Library"
            url="/media-library"
            icon={<MediaLibraryIcon />}
          />
        </List>

        <ListSubheader component="div" className={classes.subheader}>
          Campaign Management
        </ListSubheader>
        <List component="nav" className={`${classes.list} ${classes.iconList}`}>
          <AppMenuItem
            name="Campaigns"
            url="/campaigns"
            icon={<CampaignIcon />}
          />
          <AppMenuItem
            name="Broadcasts"
            url="/broadcasts"
            icon={<BroadcastIcon />}
          />
          <AppMenuItem
            name="Site Components"
            url="/site-components"
            icon={<SiteComponentIcon />}
          />
          <AppMenuItem name="Articles" url="/articles" icon={<BookIcon />} />
        </List>

        <ListSubheader component="div" className={classes.subheader}>
          Business Commerce
        </ListSubheader>
        <List component="nav" className={clsx(classes.list, classes.iconList)}>
          <AppMenuItem name="Accounts" url="/accounts" icon={<AccountIcon />} />
        </List> */}

        <ListSubheader component="div" className={classes.subheader}>
          Main
        </ListSubheader>
        <List component="nav" className={clsx(classes.list, classes.iconList)}>
        <AppMenuItem
            name="Overview"
            url="/studio"
            hash="/process-events/list/_/_"
            icon={<FormatListBulletedIcon />}
          />          
          <AppMenuItem
            name="Process Records"
            url="/studio"
            hash="/process-records"
            icon={<svg fill="currentColor" width="24" height="24">
              <path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9H9V9h10v2zm-4 4H9v-2h6v2zm4-8H9V5h10v2z"></path>
            </svg>}
          />  
        </List>
        <ListSubheader component="div" className={classes.subheader}>
          Integration Configuration
        </ListSubheader>
        <List component="nav" className={clsx(classes.list, classes.iconList)}>
          <AppMenuItem
            name="Depots"
            url="/studio"
            hash="/depots"
            icon={<svg fill="currentColor" width="24" height="24">              
                <path d="M11,17 L11,22 L6,22 L6,17 L11,17 z M12,2 C10.047,2 7.8,2.09 5.91,2.8 C3.107,3.84 1.5,6.05 1.5,8.86 L1.5,22 L5,22 L5,10.069 C5,8.926 5.988,8 7.207,8 L16.793,8 C18.012,8 19,8.926 19,10.069 C19,21.591 19.001,17.614 19,22 L22.5,22 L22.5,8.86 C22.5,6.05 20.893,3.84 18.09,2.8 C16.2,2.09 13.953,2 12,2 z M18,17 L13,17 L13,22 L18,22 L18,17 z M11,10 L6,10 L6,15 L11,15 L11,10 z" />             
            </svg>}
          />
          <AppMenuItem
            name="Processes"
            url="/studio"
            hash="/processes"
            icon={<svg fill="currentColor" width="24" height="24">
                <path d="M7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4z"></path>
              </svg>}
          />
        </List>
        <ListSubheader component="div" className={classes.subheader}>
            Email Configuration
        </ListSubheader>
        <List component="nav" className={clsx(classes.list, classes.iconList)}>
          <AppMenuItem
            name="Notifications"
            url="/studio"
            hash="/notifications"
            icon={<NotificationsIcon />}
          />        
        </List>

        {/* <ListSubheader component="div" className={classes.subheader}>
          Administration
        </ListSubheader>
        <List component="nav" className={clsx(classes.list, classes.iconList)}>
          <AppMenuItem
            name="Settings"
            url={LINKS.APP_SETTINGS}
            icon={<SettingIcon />}
          />
          <AppMenuItem name="Themes" url={LINKS.THEMES} icon={<ThemesIcon />} />
        </List> */}
      </div>
      <Divider />
      <div className={classes.bottom}>
        <HeaderUser />
      </div>
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  main: {
    flex: "1 0 0px",
    padding: theme.spacing(1),
  },
  bottom: {
    padding: theme.spacing(1),

    // backgroundColor: theme.palette.grey[200],
  },
  buttonGroup: {
    marginBottom: theme.spacing(1),
    "& > .MuiButton-root": {
      lineHeight: 1.5,
      fontSize: "1.1rem",
    },
    '& > .MuiButton-root[data-selected="true"]': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
    },
  },
  subheader: {
    lineHeight: "initial",
    padding: theme.spacing(0.5),
    fontWeight: 500,
    fontSize: "1.2rem",
    textTransform: "uppercase",
  },
  iconList: {
    padding: theme.spacing(0, 0, 2, 0),
    paddingLeft: `${theme.spacing(0)} !important`,
    "& > .MuiLink-root > .MuiListItem-root": {
      padding: `2px 2px 2px 8px !important`,
      "& > .MuiListItemText-root > .MuiTypography-displayBlock": {
        fontWeight: 500,
      },
    },
    "& > .MuiLink-root > .MuiCollapse-root > .MuiCollapse-wrapper > .MuiCollapse-wrapperInner > .MuiList-root":
      {
        paddingLeft: `${theme.spacing(4)} !important`,
      },
  },
  list: {
    paddingLeft: theme.spacing(2.5),
  },
}));

export default AppMenu;
